import { api } from '../config/api';

export const productService = {
  getAll: async (category = null) => {
    const params = category ? `?category=${category}` : '';
    return await api.get(`/products/${params}`);
  },

  getById: async (id) => {
    return await api.get(`/products/${id}/`);
  },

  create: async (product) => {
    try {
      console.log('productService.create - Enviando producto:', product);
      console.log('productService.create - Endpoint: /products');
      const response = await api.post('/products/', product);
      console.log('productService.create - Respuesta:', response);
      return response;
    } catch (error) {
      console.error('productService.create - Error:', error?.message || error);
      throw error;
    }
  },

  update: async (id, product) => {
    return await api.put(`/products/${id}/`, product);
  },

  delete: async (id) => {
    return await api.delete(`/products/${id}/`);
  },

  // Importar stock masivamente
  importStock: async (updates) => {
    return await api.post('/products/import-stock/', updates);
  },

  // Obtener historial de ajustes de stock
  getStockAdjustments: async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.product_id) queryParams.append('product_id', params.product_id);
    if (params.month) queryParams.append('month', params.month);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const endpoint = `/products/stock-adjustments/${queryString ? `?${queryString}` : ''}`;
    return await api.get(endpoint);
  },
};

